/**
 * FAQs - datos estáticos (sin API HTTP).
 */
import { config } from "common/config";
import type { Faq } from "common/models";
import { URL_TITLES } from "ui/common/pages/HelpPage/HelpPage.constants";

const STATIC_FAQS: Faq[] = [
    {
        title: "¿Qué son los puntos Pideky Escala?",
        description:
            "Es un nuevo modelo de negocio que busca conectar los programas de fidelización, lealtad e incentivos con los sueños de los clientes generando experiencias memorables. Pideky Escala prestará servicio a los socios (programas donde acumulo) como modelo de redención y a los clientes al momento de redimir los puntos ganados en sus programas, aumentando la flexibilidad, teniendo una mejor experiencia, menos intermediación y  tendrás una gran variedad de aliados donde redimir directamente. y a los aliados (Comercio donde redimo) incrementado sus ventas.",
    },
    {
        title: "¿Cómo funciona Pideky Escala?",
        description:
            "Los socios o dueños de programas activaran las billeteras digitales de los ganadores asignándoles puntos, así mismos estos clientes podrán redimir directamente en comercios físicos o ecommerce. Cada punto tendra la equivalente de $1 peso colombiano y tendrá validez en los comercios o aliados habilitados, asimismo podrán trasladarse puntos entre los clientes",
    },
    {
        title: "¿Cómo hago parte de Pideky Escala?",
        description:
            "Debes crear tu billetera digital en Pideky Escala ingresando a este link https://app.pidekyescala.com/, seleccionando la opción de registrate, lee los términos y condiciones y la autorización de tratamiento de datos personales y si estás de acuerdo dale aceptar. Usa un correo al que tengas acceso,diligencia los datos solicitados y listo , ya haces parte de Pideky Escala.",
    },
    {
        title: "¿Cómo acumular?",
        description:
            "Los clientes de Pideky Escala acumularan puntos en los programas de fidelización o incentivos de Grupo Nutresa que participen; al momento de ganar o acumular puntos se cargará en la billetera digital de Pideky Escala.",
    },
    {
        title: "¿Cómo transferir Puntos en Pideky Escala?",
        description:
            "Podrás transferir puntos a los Clientes de Pideky Escala, para esto  solo necesitas la cédula y/o el correo electrónico con el cual se encuentra registrado a quien le enviaras los puntos; solo podrás utilizar tus puntos  disponibles.",
    },
    {
        title: "¿Cuáles son los canales de atención de Pideky Escala?",
        description: "Línea whatsapp:  310 688 7349",
    },
    {
        title: "¿Mis puntos Pideky Escala tienen un vencimiento?",
        description:
            "Si, para evitar que se te venzan y tu saldo de puntos quede en cero,  debes usar tu billetera digital de Pideky Escala de manera frecuente, no la dejes de usar por más de dos (2) años.",
    },
    {
        title: "¿Cómo puedo ver los aliados donde puedo redimir mis puntos Pideky Escala?",
        description:
            "Estando en la pantalla principal de la aplicación, selecciona la opción de redimir y alli  podras ver todos nuestros aliados con redenciones en puntos de venta y en tiendas en línea (Ecommerce)",
    },
    { title: URL_TITLES.termsAndConditions, description: config.termsAndConditionsUrl },
    { title: URL_TITLES.personalDataTreatment, description: config.personalDataTreatmentUrl },
    { title: URL_TITLES.privacyPolicy, description: config.privacyPolicyUrl },
];

export const faqsApi = {
    findAll: (): Promise<Faq[]> => Promise.resolve(STATIC_FAQS),
};
